/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutContextKindPathParams = NonNullable<operations['putContextKind']['parameters']['path']>;

export type PutContextKindRequestBody = OperationRequestBodyContent<operations['putContextKind']>;

export interface Input extends PutContextKindPathParams {
  apiVersion?: string;
  body: PutContextKindRequestBody;
}

export async function putContextKind(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/api/v2/projects/{projectKey}/context-kinds/{key}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
